import {
    BreadcrumbItem,
    Breadcrumbs,
} from "@design-system/Breadcrumbs/Breadcrumbs";

export interface TrailStep<T extends string> {
    readonly id: T;
    readonly label: string;
}

interface StepTrailBreadcrumbsProps<T extends string> {
    readonly steps: ReadonlyArray<TrailStep<T>>;
    readonly currentStep: T;
    readonly onStepChange: (step: T) => void;
}

/**
 * Step trail for drawers and wizards: earlier steps go back to that step, the
 * current step is the page, and any later step is shown but cannot be opened.
 */
export const StepTrailBreadcrumbs = <T extends string>({
    steps,
    currentStep,
    onStepChange,
}: StepTrailBreadcrumbsProps<T>) => {
    const currentIndex = steps.findIndex((step) => step.id === currentStep);

    return (
        <Breadcrumbs>
            {steps.map((step, index) =>
                index === currentIndex ? (
                    <BreadcrumbItem key={step.id} current>
                        {step.label}
                    </BreadcrumbItem>
                ) : (
                    <BreadcrumbItem
                        key={step.id}
                        onClick={() => onStepChange(step.id)}
                        disabled={index > currentIndex}
                    >
                        {step.label}
                    </BreadcrumbItem>
                ),
            )}
        </Breadcrumbs>
    );
};
